export const initializeAutoCompletes = () => {
    initializeProjectAutoComplete();
    initializeWorkOrderAutoComplete();
    initializeTeamMemberAutoComplete();
    initializeVendorAutoComplete();
}

const initializeProjectAutoComplete = () => {
    const pac = $('input.js-project-autocomplete');
    if (!pac.length || pac.data('kendoAutoComplete')) return;

    const pacDs = new kendo.data.DataSource({
        serverFiltering: false,
        transport: {
            read: {
                type: 'post',
                url: '/Forms/ProjectReview/ProjectAutoComplete'
            }
        }
    });
    pacDs.fetch();
    pac.kendoAutoComplete({
        placeholder: 'Search projects...',
        filter: 'contains',
        dataSource: pacDs,
        width: '100%'
    });
}

const initializeWorkOrderAutoComplete = () => {
    const pac = $('input.js-work-order-autocomplete');
    if (!pac.length || pac.data('kendoAutoComplete')) return;

    const pacDs = new kendo.data.DataSource({
        serverFiltering: false,
        transport: {
            read: {
                type: 'post',
                url: '/AutoComplete/WorkOrderAutoComplete'
            }
        }
    });
    pacDs.fetch();
    pac.kendoAutoComplete({
        placeholder: 'Search work orders...',
        filter: 'contains',
        dataSource: pacDs,
        width: '100%'
    });
}

const initializeTeamMemberAutoComplete = () => {
    const $autoComplete = $('input.js-team-member-autocomplete')

    if ($autoComplete.length > 0 && !$autoComplete.data('kendoAutoComplete'))
        teamMemberAutoComplete($autoComplete);

    const $autoCompleteAll = $('input.js-team-member-autocomplete__all');
    if ($autoCompleteAll.length > 0 && !$autoCompleteAll.data('kendoAutoComplete'))
        teamMemberAutoComplete($autoCompleteAll, true);
}

const teamMemberAutoComplete = ($autoComplete, shouldFetchAll) => {

    let url = '/Forms/ProjectReview/TeamMemberAutoComplete';
    if (shouldFetchAll) url += '?company=0';
    const autoCompleteData = new kendo.data.DataSource({
        serverFiltering: false,
        transport: {
            read: {
                type: 'post',
                url: url
            }
        }
    });
    autoCompleteData.fetch();
    return $autoComplete.kendoAutoComplete({
        placeholder: 'Search Team Members...',
        filter: 'contains',
        dataSource: autoCompleteData,
        width: '100%'
    }).data('kendoAutoComplete');
}

const initializeVendorAutoComplete = () => {
    const $autoComplete = $('input.js-vendor-autocomplete');
    if (!$autoComplete.length || $autoComplete.data('kendoAutoComplete')) return;
    const autoCompleteData = new kendo.data.DataSource({
        serverFiltering: false,
        transport: {
            read: {
                type: 'post',
                url: '/AutoComplete/VendorAutoComplete'
            }
        }
    });
    autoCompleteData.fetch();
    $autoComplete.kendoAutoComplete({
        placeholder: 'Search Vendors...',
        dataTextField: "Name",
        filter: 'contains',
        dataSource: autoCompleteData,
        width: '100%'
    });
}
